import { render, staticRenderFns } from "./MonthlySalesComparisionReport.vue?vue&type=template&id=2d993656&scoped=true&"
import script from "./MonthlySalesComparisionReport.vue?vue&type=script&lang=js&"
export * from "./MonthlySalesComparisionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d993656",
  null
  
)

export default component.exports